import { isIdXboxGameInformationTechnicalCapabilitiesFormValid } from "../../../../helpers/formValidation";
import {
  GameInformationTechnicalCapabilitiesDataType,
  SubFormsDataTypes,
} from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const TechnicalCapabilitiesDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const technicalCapabilitiesData = data as GameInformationTechnicalCapabilitiesDataType;
    if (!technicalCapabilitiesData) {
      return { result: true };
    }

    const validSchema =
      await isIdXboxGameInformationTechnicalCapabilitiesFormValid(technicalCapabilitiesData);
    return { result: validSchema };
  },
};
